import { forwardRef, type Ref, type SVGProps } from "react";
const IconLocationFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2A10 10 0 0 0 6 12c0 8 10 18 10 18s10-10 10-18A10 10 0 0 0 16 2m0 14a4 4 0 1 1 4-4 4 4 0 0 1-4 4" />
  </svg>
);
const ForwardRef = forwardRef(IconLocationFilledSVG);
ForwardRef.displayName = "IconLocationFilled";
export { ForwardRef as IconLocationFilled };
